import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import * as wConsts from "../consts/website-consts";
import * as adActs from "../actions/advertise-actions";
import * as lActs from "../actions/links-actions";
import * as wActs from "../actions/website-actions";

import SeoHeaders from "../components/seoheaders";
import { Widget } from "@uploadcare/react-widget";
import SideBanners from "../components/sidebanners";
import Select from "react-select";

class Submit extends Component {

  constructor(props) {
    super(props);
    this.state = {
      regSelect: "block",
      regForm: "none",
      cc: "",
      cities: props.Cities,
      img: "", width: 0, height: 0
    };
  }

  componentDidMount() {
    this.props.dispatch({ type: wConsts.ACTION_SET_PAGETYPE, payload: "submitlink" });
  }

  handleClick(evt, tType) {
    evt.preventDefault();
    this.props.dispatch({ type: wConsts.SIGNUP_SET_TYPE, payload: tType });
    this.setState({
      regSelect: "none",
      regForm: "block"
    });
  }

  getTranslation(key) {
    return this.props.WebPage.Translations[key];
  }

  handleCloseAlert() {
    this.setState({ showingAlert: false });
  }
  handleCloseSuccess() {
    this.setState({ showingSuccess: false });
  }


  changeCountry(sel) {
    if(wActs.isNullOrUndefined(sel)) {
      return;
    }
    if(wActs.isNullOrUndefined(sel.value)) {
      return;
    }
    let self = this;
    let cc = sel.value;
    fetch(`/api/cities?cc=${cc}&lang=${this.props.WebPage.Settings.SelectedLang}`,{headers: {}, method: "GET"})
      .then(resp => resp.json())
      .then(function(data) {
        if(data.Code == 200) {
          self.setState({cities: data.Result.map((v) => {return {label: v.Name, value: v.Code, record: v}})});
        }
      }).catch((ex) => {
    });
  }


  handleSubmit(evt) {
    evt.preventDefault();
    const data = {
      url: this.Url.value,
      title: this.Title.value,
      description: this.Description.value,
      countryCode: this.Country.state.value ? this.Country.state.value.value : "US",
      city: this.City.state.value ? this.City.state.value.value : "",
      categoryId: this.Category.state.value ? this.Category.state.value.value : 0,
      summary: this.Summary.value,
      body: "", img: this.state.img, email: this.Email.value, backlinkurl: this.BacklinkUrl.value
    };

    this.props.dispatch(lActs.submitLink(data));

  }

  PopupCenter(url, title, w, h) {
    const dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screenX;
    const dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screenY;

    const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    const left = ((width / 2) - (w / 2)) + dualScreenLeft;
    const top = ((height / 2) - (h / 2)) + dualScreenTop;
    const newWindow = window.open(url, title, 'toolbar=0,scrollbars=0,location=0,statusbar=0,menubar=0,resizable=0, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

    // Puts focus on the newWindow
    if (window.focus) {
      newWindow.focus();
    }

    return newWindow;
  }


  handleUrlChange(e) {
    let val = e.target.value;
    this.BacklinkUrl.value = val;
    if(typeof this.props.handleUrlChange === "function") {
      this.props.handleUrlChange(e,val);
    }
    if(val.startsWith("http://") || val.startsWith("https://")) {
      if(this.iFramely) {this.iFramely.innerHTML = "";}
      this.props.dispatch(adActs.GetAdUrlInfo(val));
    }
  }



  render() {
    let defTitle = "";
    let defDesc = "";
    let adUrl = this.props.Ads.AdUrl;
    if(adUrl.Loaded && adUrl.Result.Code == 200) {
      try {
        defTitle = adUrl.Result.Result.Title.trim();
        defDesc = adUrl.Result.Result.Description.trim();
      } catch(ex) {}
    }

    let sSuc = this.props.isPosted;


    return (

      <React.Fragment>
        <SeoHeaders Position={"Top"}/>
        <div className="row">
          <div className="col_80">
            <div className="white-box the-content">

              {!sSuc &&
              <div className="heading">
                <div className="cell x12">
                  {typeof window !== "undefined" &&
                  <p dangerouslySetInnerHTML={{__html: this.getTranslation("page.submitlinkrules")}}></p>
                  }
                </div>
                <div className="clear"></div>
              </div>
              }
              <div className="form">
                <div className="cell x12">

                  {!sSuc &&
                  <form action="">
                    <label htmlFor="">{this.getTranslation("page.advertise.targeturl")}/{this.getTranslation("page.advertise.title")}</label>
                    <input ref={(r) => {this.Url = r}} onBlur={(e) => {this.handleUrlChange(e)}} type="text" placeholder="https://...."/>
                    {this.props.Ads.AdUrl.Loaded &&
                    <React.Fragment>
                      {!wActs.isNullOrEmpty(this.props.Ads.AdUrl.Result) && !wActs.isNullOrEmpty(this.props.Ads.AdUrl.Result.Result) && !wActs.isNullOrEmpty(this.props.Ads.AdUrl.Result.Result.Html) &&
                      <div className="ad-greybox" ref={(ref) => {this.iFramely = ref}}></div>
                      }
                    </React.Fragment>
                    }
                    {this.props.Ads.AdUrl.Loading &&
                    <p style={{width: "100%", display: "flex", alignContent: "center", justifyContent: "center"}}>
                      <img src="/imgs/loader.gif" width={"50px"} height={"50px"} alt={"Loading"}/>
                    </p>
                    }
                    <input ref={(r) => {this.Title = r}} type="text" placeholder={this.getTranslation("page.advertise.title")} value={defTitle} style={{marginBottom: "2px"}}/>
                    <div className="col_100" style={{color: "Red", fontSize: "11px", marginBottom: "12px"}}>{this.getTranslation("page.submitlink.wesuggestamaxofxchars").replace("{{Count}}","55")}</div>
                    <input ref={(r) => {this.Description = r}} type="text" placeholder={this.getTranslation("dash.description")} value={defDesc} style={{marginBottom: "2px"}}/>
                    <div className="col_100" style={{color: "Red", fontSize: "11px", marginBottom: "12px"}}>{this.getTranslation("page.submitlink.wesuggestamaxofxchars").replace("{{Count}}","140")}</div>
                    <label htmlFor="">{this.getTranslation("page.profile.location")}</label>
                    <div className="cell x6 submit" style={{paddingLeft: "0px"}}><Select ref={(r) => {this.Country = r}} onChange={(sel) => {this.changeCountry(sel)}} options={this.props.Countries} placeholder={this.getTranslation("dash.list.select")+"..."}/></div>
                    <div className="cell x6 submit" style={{paddingRight: "0px"}}><Select ref={(r) => {this.City = r}} options={this.state.cities} placeholder={this.getTranslation("dash.list.select")+"..."}/></div>
                    <div className="clear" style={{marginBottom: "15px"}}></div>
                    <label htmlFor="">{this.getTranslation("page.category")}</label>
                    <Select  ref={(r) => {this.Category = r}} options={this.props.Categories} placeholder={this.getTranslation("dash.list.select")+"..."}/>
                    <div className="clear" style={{marginBottom: "15px"}}></div>
                    <label htmlFor="">{this.getTranslation("page.submitlink.summary")}</label>
                    <textarea ref={(r) => {this.Summary = r}} placeholder={this.getTranslation("page.submitlink.summaryofyourwebsite")}></textarea>
                    <label htmlFor="">{this.getTranslation("page.email")}</label>
                    <input ref={(r) => {this.Email = r}} type="text" placeholder="email@somedomain.com" defaultValue={this.props.WebPage.User.EmailAddress}/>
                    <label htmlFor="">Backlink Url</label>
                    <input ref={(r) => {this.BacklinkUrl = r}} type="text" placeholder="https://..."/>

                    <div className="row">
                      <div className="col_100">
                        <label htmlFor="">{this.getTranslation("dash.banner")}</label>
                      </div>
                      <div className="col_100">
                        <Widget publicKey={"ff11d3fc8febee37b61d"} id={"MainImage"} previewStep={true}
                                onChange={(file) => {
                                  console.log("File Changed", file);
                                  this.setState({img: file.cdnUrl});
                                }}
                        />
                      </div>
                      <div className="col_100" style={{color: "Red", fontSize: "11px", margin: "5px 5px"}}>{this.getTranslation("dash.companybanner")}</div>
                      <div className="col_100" style={{color: "Red", fontSize: "11px", margin: "5px 5px"}}>{this.getTranslation("page.advertise.ifyoudonothaveabanner")}</div>
                    </div>


                    {!wActs.isNullOrEmpty(this.state.img) &&
                    <div className="row">
                      <div className="col_100">
                        <img src={this.state.img} style={{width: "468px", maxWidth: "100%", margin: "3px"}}/>
                      </div>
                    </div>
                    }


                    <div className="clear" style={{marginBottom: "15px"}}></div>
                    {!this.props.isPosting &&
                    <input onClick={(e) => {this.handleSubmit(e)}} type="submit" value={this.getTranslation("page.submit")}/>
                    }
                    {this.props.isPosting &&
                    <div className="cell x12" style={{display: "flex", justifyContent: "center"}}><img src="/imgs/loader.gif" style={{width: "50px"}}/></div>
                    }
                  </form>
                  }

                  {sSuc &&
                  <React.Fragment>
                    <div className="cell x12 flex-center">
                      <i className="fa fa-check-circle green" style={{fontSize: "175px", color: "limegreen"}}/>
                    </div>
                    <div className="cell x12 flex-center" style={{margin: "20px auto" }}>
                      {this.getTranslation("page.links.linksubmitted")}
                    </div>
                    <div className="cell x12 flex-center" style={{margin: "20px auto" }}>
                      <form><input type={"submit"} onClick={(e)=>{e.preventDefault(); this.props.history.push(wActs.getCultPath(this.props.WebPage, "/")); }} value={this.getTranslation("menu.home")} /></form>
                    </div>


                  </React.Fragment>
                  }

                  {(typeof window !== "undefined" && !sSuc) &&
                    <p style={{textAlign: "center"}} dangerouslySetInnerHTML={{__html: this.getTranslation("page.submitlink.timewarning")}}></p>
                  }


                <div className="clear" style={{marginBottom: "400px"}}></div>
              </div>
            </div>
            </div>
          </div>
          <SideBanners/>
        </div>
      </React.Fragment>
    );
  }
  componentDidUpdate() {
    let adUrl = this.props.Ads.AdUrl;
    if (this.iFramely && !this.iFramely.hasChildNodes()) {
      if (adUrl.Loaded && adUrl.Result.Code == 200 && adUrl.Result.Result.Html) {
        const range = document.createRange();
        this.iFramely.appendChild(range.createContextualFragment(adUrl.Result.Result.Html));
      }
    }
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website,
    Categories: state.Tags.Tags.Categories.map((v) => {return {label: v.Name, value: v.Id, record: v}}),
    Countries: state.Tags.Tags.Countries.map((v) => {return {label: v.Name, value: v.Code, record: v}}),
    Cities: state.Tags.Tags.Cities.map((v) => {return {label: v.Name, Value: v.Code, record: v}}),
    Ads: state.Ads,
    isPosting: state.Links.SubmitLink.Posting,
    isPosted: state.Links.SubmitLink.Loaded
  };
};

export default connect(mapStateToProps)(Submit);
